//automatically installed with react router dom
import { createBrowserHistory as createHistory } from "history";

export default createHistory();
